// import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//   token: null,
//   isvarified: false,
//   userInfo: null,

// };

// const authSlice = createSlice({
//   name: "auth",
//   initialState,
//   reducers: {
//     loginSuccess: (state, action) => {
//       state.token = action.payload.token || null;
//       state.userInfo = action.payload.userInfo || null;
//       state.isvarified = action.payload.isvarified || false;
 
//     },
//     logout: (state) => {
//       state.token = null;
//       state.userInfo = null;
//       state.isvarified = false;
//       state.loginTime = null;
//     },
//   },
// });

// export const { loginSuccess, logout } = authSlice.actions;
// export default authSlice.reducer;


import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userInfo: null,
  isvarified: false,
  authReady: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.userInfo = action.payload.userInfo;
      state.isvarified = true;
      state.authReady = true;
    },
    setSessionUser: (state, action) => {
      state.userInfo = action.payload;
      state.isvarified = true;
      state.authReady = true;
    },
    setAuthReady: (state, action) => { state.authReady = action.payload; },
    updateUserInfo: (state, action) => {
      state.userInfo = { ...state.userInfo, ...action.payload };
    },
    logout: (state) => {
      state.userInfo = null;
      state.isvarified = false;
      state.authReady = true;
    },
  },
});

export const { loginSuccess, logout, setSessionUser, setAuthReady, updateUserInfo } = authSlice.actions;
export default authSlice.reducer;
